// extracted by mini-css-extract-plugin
export default {"titleBox":"favorites_titleBox__Xul9m","container":"favorites_container__qB5Sh","productBox":"favorites_productBox__UXgzz","filterBox":"favorites_filterBox__0D14W"};